if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.freeShippingNoticeATCPopup = document.getElementById('free-shipping-notice-atc-popup');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        //console.log('-------> this.cartDrawer exists', sections);
      } else if(this.freeShippingNoticeATCPopup) {
        sections += ',free-shipping-notice,free-shipping-notice-atc-placeholder';
        //console.log('----------> this.cartDrawer DOES NOT EXIST', sections);
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);
          ProductForm.updateFreeShippingNoticeATCPopup(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }
    
    /**
     * Updates FreeShippingNoticeATCPopup
     * @param {object} response - Response JSON.
     */
    static updateFreeShippingNoticeATCPopup(response) {
      const freeShippingNoticeATCPopup = document.querySelector('#free-shipping-notice-atc-placeholder #free-shipping-notice');
      if (freeShippingNoticeATCPopup) {
        freeShippingNoticeATCPopup.innerHTML = response.sections['free-shipping-notice'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }
  customElements.define('product-form', ProductForm);
}

if (!customElements.get('selling-plan-picker')) {
  class SellingPlanPicker extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback(){
      const purchseOptions = this.querySelectorAll('[name="purchase-option"]');
      const sellingPlanSelects = this.querySelectorAll('clever-select.selling-plan-select');
      for(const purchseOption of purchseOptions) {
        purchseOption.addEventListener('input', event => {
          if(purchseOption.value == 'subscription') {
            const label = this.querySelector(`label[for="${purchseOption.id}"]`);
            const sellingPlan = label.querySelector('input[name="current-selling-plan"]');
            if(!!sellingPlan){
              this.setSellingPlan(sellingPlan.value);
            }
          }
          if(purchseOption.value == 'onetime') {
            this.removeSellingPlan();
          }
        });
      }
      for(const sellingPlanSelect of sellingPlanSelects) {
        sellingPlanSelect.addEventListener('change', event => {
          const sellingPlan = sellingPlanSelect.querySelector('input[name="current-selling-plan"]');
          if(!!sellingPlan){
            this.setSellingPlan(sellingPlan.value);
          }
        });
      }
    }
    updateDOM(newURL, sellingPlanId){
      const that = this;
      const sectionId = that.dataset.sectionId;
      that.classList.remove('loading');
      fetch(newURL, {
        credentials: 'same-origin',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
        method: 'GET'
      })
      .then(response => response.text())
      .then(data => {
        let template = document.createElement('template');
        template.innerHTML = data.trim();
        const newPDP = template.content;
        const oldPDP = document.querySelector(`#shopify-section-${sectionId}`);
        const selectorsToUpdate = [
          '.product-info__selling_plans',
          '.product-info__price',
          'product-form'
        ];
        selectorsToUpdate.forEach(selector => {
          const newElement = newPDP.querySelector(selector);
          const oldElement = oldPDP.querySelector(selector);
          if(!!newElement && !!oldElement) {
            oldElement.replaceWith(newElement);
          }
        });
        window.dispatchEvent(new CustomEvent('sellingplan:changed', {bubbles: true, cancelable: false, detail: sellingPlanId}));
        that.classList.remove('loading');
      })
      .catch(function(err) {
        that.classList.remove('loading');
        console.error(err);
      });
    }
    updateURL(variantId, sellingPlanId){
      const params = (new URL(document.location)).searchParams;
      if(!!variantId){
        params.set('variant', variantId);
      } else {
        params.delete('variant');
      }
      if(!!sellingPlanId){
        params.set('selling_plan', sellingPlanId);
      } else {
        params.delete('selling_plan');
      }
      let newUrl = (new URL(document.location));
      newUrl.search = params.toString();
      let newHistoryState = newUrl.href.split('/').pop();
      history.replaceState(null, '', newHistoryState);
    }
    setSellingPlan(sellingPlanId) {
      let form = this.closest('form.shopify-product-form');
      if(!form){
        form = this.closest('.shopify-section').querySelector('product-form form');
      }
      const current_variant_input = form.querySelector('input[name="id"]');
      const variantId = current_variant_input.value;
      this.updateURL(variantId, sellingPlanId);

      const sectionId = this.dataset.sectionId;
      const productUrl = this.dataset.productUrl;
      const newURL = `${productUrl}?variant=${variantId}&selling_plan=${sellingPlanId}&section_id=${sectionId}`;
      this.updateDOM(newURL, sellingPlanId);
    }
    removeSellingPlan() {
      let form = this.closest('form.shopify-product-form');
      if(!form){
        form = this.closest('.shopify-section').querySelector('product-form form');
      }
      const current_variant_input = form.querySelector('input[name="id"]');
      const variantId = current_variant_input.value;
      this.updateURL(variantId, null);

      const sectionId = this.dataset.sectionId;
      const productUrl = this.dataset.productUrl;
      const newURL = `${productUrl}?variant=${variantId}&section_id=${sectionId}`;
      this.updateDOM(newURL, null);
    }
    changeVariant(variantId) {
      let form = this.closest('form.shopify-product-form');
      if(!form){
        form = this.closest('.shopify-section').querySelector('product-form form');
      }
      const sellingPlanId = (new URL(document.location)).searchParams.get('selling_plan');
      const sectionId = this.dataset.sectionId;
      const productUrl = this.dataset.productUrl;
      const newURL = `${productUrl}?variant=${variantId}&selling_plan=${sellingPlanId}&section_id=${sectionId}`;
      this.updateDOM(newURL, sellingPlanId);
    }
  }
  customElements.define('selling-plan-picker', SellingPlanPicker);
}

if (!customElements.get('selected-option')) {
  customElements.define('selected-option', class extends HTMLElement { });
}
if (!customElements.get('clever-options')) {
  customElements.define('clever-options', class extends HTMLElement { });
}
if (!customElements.get('clever-option')) {
  customElements.define('clever-option', class extends HTMLElement { });
}

if (!customElements.get('clever-select')) {
  class CleverSelect extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const that = this;
      //Wrap options in custom container
      this._wrapOptions();

      //create value holding input
      this._createValueHolder();

      //Get all options
      this.options = this.querySelectorAll('clever-option')

      //Create selected option display
      this._createSelectedOptionDisplay()

      //Set event listener for toggling the Select
      this.querySelector('selected-option').addEventListener('click', (e) => {
        that.toggleOpenState();
      })
      this.options.forEach(option => {
        //Set initial selected option
        if (option.hasAttribute('selected')) {
          that._setSelectedOption(option, false)
        }
        //Add event listeners to all options
        option.addEventListener('click', (e) => {
          if (!option.hasAttribute('disabled')) {
            e.preventDefault()
            that._setSelectedOption(option)
            that.close();
          }
        })
      })

      //Set event listener to close when focus out
      document.body.addEventListener('click', (e) => {
        if (that.hasAttribute('open')) {
          const boundingBox = that.getBoundingClientRect();
          const clickInside = e.clientX > boundingBox.x && e.clientX < boundingBox.x + boundingBox.width && e.clientY > boundingBox.y && e.clientY < boundingBox.y + boundingBox.height;
          if (!clickInside) {
            that.close()
          }
        }
      })
    }
    toggleOpenState() {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open')
      }
      else {
        this.setAttribute('open', '')
      }
    }
    close() {
      this.removeAttribute('open')
    }

    //this functions should only be used by the element itself
    _setSelectedOption(option, events = true) {
      this.value = option.getAttribute('value')
      this.options.forEach(option => {
        option.removeAttribute('selected')
      })
      option.setAttribute('selected', true)
      this.setAttribute('value', this.value)
      this.input.setAttribute('value', this.value)
      this.selectedOption.innerHTML = option.innerHTML;
      if (events) {
        this.input.dispatchEvent(new Event('change', { bubbles: true, cancelable: false, composed: true }))
        this.input.dispatchEvent(new Event('input', { bubbles: true, cancelable: false, composed: true }))
      }
    }
    _wrapOptions() {
      let wrappedContent = document.createElement('clever-options');
      let options = this.querySelectorAll('option')
      options.forEach(o => {
        let no = document.createElement('clever-option')
        no.value = o.value;
        no.setAttribute('value', o.value)
        if (o.hasAttribute('selected')) {
          no.selected = o.selected;
          no.setAttribute('selected', o.selected)
        }
        if (o.hasAttribute('disabled')) {
          no.disabled = o.disabled;
          no.setAttribute('disabled', o.disabled)
        }


        no.innerHTML = o.innerHTML;
        wrappedContent.appendChild(no)
      })
      this.innerHTML = wrappedContent.outerHTML;
    }
    _createSelectedOptionDisplay() {
      this.selectedOption = document.createElement('selected-option');
      this.selectedOption.innerHTML = String(this.getAttribute('placeholder'))
      this.appendChild(this.selectedOption)
    }
    _createValueHolder() {
      this.input = document.createElement('input')
      this.input.type = 'text'
      this.input.setAttribute('hidden', '')
      this.input.setAttribute('name', this.getAttribute('name'))
      this.removeAttribute('name')
      this.appendChild(this.input)
    }
  }
  customElements.define('clever-select', CleverSelect);
}